/**
 * /frontend/src/features/analytics/components/shared/ZoneSectionFilter.js
 */

import React from 'react';
import './DateRangeFilter.css';
import './ZoneSectionFilter.css';

/**
 * Zone/Section filter selectors.
 * @param {{zoneId:string,sectionId:string,zones:Array<{id:string,label:string}>,sections:Array<{id:string,label:string}>,onZoneChange:Function,onSectionChange:Function}} props
 * @returns {JSX.Element}
 */
const ZoneSectionFilter = ({
  zoneId,
  sectionId,
  zones,
  sections,
  onZoneChange,
  onSectionChange
}) => (
  <div className="analytics-zone-section">
    <div className="analytics-date-field">
      <label htmlFor="analytics-zone">Zone</label>
      <select id="analytics-zone" value={zoneId} onChange={(event) => onZoneChange(event.target.value)}>
        <option value="">All</option>
        {(zones || []).map((zone) => (
          <option key={zone.id} value={zone.id}>{zone.label}</option>
        ))}
      </select>
    </div>
    <div className="analytics-date-field">
      <label htmlFor="analytics-section">Section</label>
      <select id="analytics-section" value={sectionId} onChange={(event) => onSectionChange(event.target.value)}>
        <option value="">All</option>
        {(sections || []).map((section) => (
          <option key={section.id} value={section.id}>{section.label}</option>
        ))}
      </select>
    </div>
  </div>
);

export default ZoneSectionFilter;

